var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "a-upload",
        {
          attrs: {
            headers: _vm.headers,
            accept: _vm.accept,
            action: _vm.url || _vm.action,
            "list-type": "picture-card",
            multiple: _vm.num > 1,
            showUploadList: false,
          },
          on: { change: _vm.handleChange, preview: _vm.handlePreview },
        },
        [
          _vm.fileList.length < _vm.num
            ? _c(
                "div",
                [
                  _c("a-icon", { attrs: { type: "plus" } }),
                  _c("div", { staticClass: "ant-upload-text" }, [
                    _vm._v(" 上传 "),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _c(
        "div",
        { staticClass: "file_list fix" },
        _vm._l(_vm.fileList, function (item, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "file_list_item",
              attrs: {
                href: _vm._f("fileWxPath")(item.url),
                title: _vm._f("fileWxPath")(item.url),
              },
            },
            [
              item.url.includes(".txt") || item.url.includes(".TXT")
                ? _c("a-icon", { attrs: { type: "file-text" } })
                : item.url.includes(".pdf") || item.url.includes(".PDF")
                ? _c("a-icon", { attrs: { type: "file-pdf" } })
                : item.url.includes(".ppt") || item.url.includes(".PPT")
                ? _c("a-icon", { attrs: { type: "file-ppt" } })
                : item.url.includes(".doc") || item.url.includes(".DOC")
                ? _c("a-icon", { attrs: { type: "file-word" } })
                : item.url.includes(".zip") ||
                  item.url.includes("rar") ||
                  item.url.includes(".ZIP") ||
                  item.url.includes(".RAR")
                ? _c("a-icon", { attrs: { type: "file-zip" } })
                : item.url.includes(".xls") || item.url.includes(".XLS")
                ? _c("a-icon", { attrs: { type: "file-excel" } })
                : item.url.includes(".png") ||
                  item.url.includes(".jpg") ||
                  item.url.includes(".jpeg") ||
                  item.url.includes(".gif") ||
                  item.url.includes(".PNG") ||
                  item.url.includes(".JPG") ||
                  item.url.includes(".JPEG") ||
                  item.url.includes(".GIF") ||
                  item.url.includes("wework.qpic.cn")
                ? _c("img", {
                    attrs: { src: _vm._f("fileWxPath")(item.url), alt: "" },
                  })
                : item.url.toLowerCase().includes(".ogm") ||
                  item.url.toLowerCase().includes(".wmv") ||
                  item.url.toLowerCase().includes(".mpg") ||
                  item.url.toLowerCase().includes(".webm") ||
                  item.url.toLowerCase().includes(".ogv") ||
                  item.url.toLowerCase().includes(".mov") ||
                  item.url.toLowerCase().includes(".asx") ||
                  item.url.toLowerCase().includes(".mpeg") ||
                  item.url.toLowerCase().includes(".mp4") ||
                  item.url.toLowerCase().includes(".m4v") ||
                  item.url.toLowerCase().includes(".avi")
                ? _c("a-icon", { attrs: { type: "video-camera" } })
                : _c("a-icon", { attrs: { type: "file-unknown" } }),
              _c(
                "div",
                { staticClass: "item_cover" },
                [
                  !_vm.disabled
                    ? _c(
                        "a",
                        {
                          attrs: {
                            download: _vm._f("fileWxPath")(item.url),
                            href: _vm._f("fileWxPath")(item.url),
                            target: "_blank",
                          },
                        },
                        [
                          item.url.includes(".txt") ||
                          item.url.includes(".pdf") ||
                          item.url.includes(".txt") ||
                          item.url.includes(".ppt") ||
                          item.url.includes(".doc") ||
                          item.url.includes(".zip") ||
                          item.url.includes(".xls") ||
                          item.url.includes(".TXT") ||
                          item.url.includes(".PDF") ||
                          item.url.includes(".TXT") ||
                          item.url.includes(".PPT") ||
                          item.url.includes(".DOC") ||
                          item.url.includes(".ZIP") ||
                          item.url.includes(".XLS")
                            ? _c("a-icon", {
                                attrs: { type: "arrow-down", title: "下载" },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: _vm._f("fileWxPath")(item.url),
                        target: "_blank",
                      },
                    },
                    [
                      item.url.includes(".png") ||
                      item.url.includes(".jpg") ||
                      item.url.includes(".jpeg") ||
                      item.url.includes(".gif") ||
                      item.url.includes(".PNG") ||
                      item.url.includes(".JPG") ||
                      item.url.includes(".JPEG") ||
                      item.url.includes(".GIF") ||
                      item.url.includes("wework.qpic.cn")
                        ? _c("a-icon", {
                            attrs: { type: "eye", title: "查看" },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: _vm._f("fileWxPath")(item.url),
                        target: "_blank",
                      },
                    },
                    [
                      item.url.toLowerCase().includes(".ogm") ||
                      item.url.toLowerCase().includes(".wmv") ||
                      item.url.toLowerCase().includes(".mpg") ||
                      item.url.toLowerCase().includes(".webm") ||
                      item.url.toLowerCase().includes(".ogv") ||
                      item.url.toLowerCase().includes(".mov") ||
                      item.url.toLowerCase().includes(".asx") ||
                      item.url.toLowerCase().includes(".mpeg") ||
                      item.url.toLowerCase().includes(".mp4") ||
                      item.url.toLowerCase().includes(".m4v") ||
                      item.url.toLowerCase().includes(".avi")
                        ? _c("a-icon", {
                            attrs: { type: "eye", title: "查看" },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  !_vm.disabled
                    ? _c("a-icon", {
                        attrs: { type: "delete", title: "删除" },
                        on: {
                          click: function ($event) {
                            return _vm.removeFile(index)
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        }),
        0
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showLoading,
              expression: "showLoading",
            },
          ],
          staticClass: "loading-container",
        },
        [_c("a-spin", { attrs: { size: "large" } })],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }